import { InsideLayout, DocumentLayout, WorkLayout } from '@/layouts/index.js'
const constantRouterMap = [
  {
    path: '/',
    redirect: location.host.includes('wms-open.eccang.com') ? '/work/credentials' : '/home'
  },
  {
    path: '/loading',
    name: 'LoadingLogin',
    component: () => import('@/views/LoadingLogin.vue')
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/index/home.vue')
  },
  {
    path: '/',
    component: InsideLayout,
    children: [
      {
        path: '/agreement',
        name: 'Agreement',
        component: () => import('@/views/Agreement.vue')
      },
      {
        path: '/policyModal',
        name: 'PolicyModal',
        component: () => import('@/views/PolicyModal.vue')
      },
      {
        path: '/callMe',
        name: 'CallMe',
        component: () => import('@/views/CallMe.vue')
      }
    ]
  },
  {
    path: '/docCenter',
    name: 'DocumentCenterLayout',
    redirect: '/documentCenter',
    component: DocumentLayout,
    children: [
      {
        path: '/documentCenter',
        name: 'DocumentCenter',
        component: () => import('@/views/DocumentCenter/DocumentCenter.vue')
      },
      {
        path: '/seachDoc',
        name: 'SeachDoc',
        component: () => import('@/views/DocumentCenter/SeachDoc.vue')
      }
    ]
  },
  {
    path: '/work',
    name: 'WorkLayout',
    component: WorkLayout,
    children: [
      {
        path: 'credentials',
        name: 'Credentials',
        component: () => import('@/views/work/Credentials/Credentials.vue')
      },
      {
        path: 'applied',
        name: 'Applied',
        component: () => import('@/views/work/Applied/Applied.vue')
      },
      {
        path: 'applied/operationLog',
        name: 'OperationLog',
        component: () => import('@/views/work/ChildAct/OperationLog.vue')
      },
      {
        path: 'interDiary',
        name: 'InterDiary',
        component: () => import('@/views/work/InterDiary/InterDiary.vue')
      },
      {
        path: 'api',
        name: 'Api',
        component: () => import('@/views/work/Api/Api.vue')
      },
      {
        path: 'childAct',
        name: 'ChildAct',
        component: () => import('@/views/work/ChildAct/ChildAct.vue')
      },
      {
        path: 'childAct/operationLog',
        name: 'OperationLog',
        component: () => import('@/views/work/ChildAct/OperationLog.vue')
      }
    ]
  }
]

export {
  constantRouterMap
}
